import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Grid, Row, Panel, Accordion } from 'react-bootstrap';
import "./analyticsManagement.css";
import { FileUploader, Button, TextBox } from 'devextreme-react';
import notify from 'devextreme/ui/notify';
import DataGrid, {
    Column, ColumnChooser, ColumnFixing, Sorting, Scrolling, Format, FilterRow, Paging, Selection,
    HeaderFilter,
    FilterPanel
} from 'devextreme-react/data-grid';
import { Popup } from 'devextreme-react/popup';
import AnalyticsDownloadCell from './analyticsDownloadCell.jsx';


export default class AnalyticsManagement extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newDocVisible: false,
            selectedFiles: [],
            analyticsItems: [],
            removeButtonVisible: false,
            selectedAnalytics: [],
            confirmRemoveVisible: false
        };

        this.showAddDocument = this.showAddDocument.bind(this);
        this.hideNewDocument = this.hideNewDocument.bind(this);
        this.onSelectedFilesChanged = this.onSelectedFilesChanged.bind(this);
        this.refreshData = this.refreshData.bind(this);
        this.formElement = React.createRef();
        this.onClick = this.onClick.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onSelectionChanged = this.onSelectionChanged.bind(this);
        this.onRemoveButtonClick = this.onRemoveButtonClick.bind(this);
        this.onConfirmRemoveClick = this.onConfirmRemoveClick.bind(this);
        this.onCancelRemoveClick = this.onCancelRemoveClick.bind(this);
        this.hideConfirmRemove = this.hideConfirmRemove.bind(this);
        this.onCancelDownloadClick = this.onCancelDownloadClick.bind(this);
        this.onTimer = this.onTimer.bind(this);
    }

    onCancelDownloadClick() {
        this.hideNewDocument();
    }

    onConfirmRemoveClick() {
        this.removeSelectedAnalytics();
    }

    onCancelRemoveClick() {
        this.hideConfirmRemove();
    }

    hideConfirmRemove() {
        this.setState({ confirmRemoveVisible: false })
    }

    onRemoveButtonClick(e) {
        this.setState({ confirmRemoveVisible: true });
    }

    removeSelectedAnalytics() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        var operationData = {
            list: []
        };

        for (var i = 0; i < this.state.selectedAnalytics.length; i++) {
            operationData.list.push(this.state.selectedAnalytics[i].analyticsId);
        };

        fetch('api/main/RemoveAnalytics', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify(operationData)
        })
            .then(response => response.json())
            .then(data => {
                notify(data.message, data.isSucceeded ? 'success' : 'error', 3000);
                this.hideConfirmRemove();
                this.refreshData();
            });
    }

    onSelectionChanged(e) {
        if (e.selectedRowsData.length > 0) {
            this.setState({ removeButtonVisible: true, selectedAnalytics: e.selectedRowsData });
        } else {
            this.setState({ removeButtonVisible: false });
        }
    }

    showAddDocument() {
        this.setState({ newDocVisible: true });
    }

    hideNewDocument() {
        this.setState({ newDocVisible: false });
    }

    onSelectedFilesChanged(e) {
        this.setState({ selectedFiles: e.value });
    }

    onClick() {
        this.formElement.current.submit();
        this.refreshTimer = setInterval(this.onTimer, 500);
    }

    onTimer() {
        if (this.frame.contentDocument.body.innerText != "") {
            clearInterval(this.refreshTimer);
            if (this.frame.contentDocument.body.innerText == "success") {
                notify("Файлы обработаны", 'success', 3000);
            } else {
                notify("Не удалось выполнить операцию", 'error', 3000);
            };
            this.frame.contentDocument.body.innerHTML = "";
            this.hideNewDocument();
            this.refreshData();
        }
    }

    componentDidMount() {
        this.refreshData();        
        this.frame = document.getElementById('dummyframe');        
    }

    refreshData() {
        var tokenKey = "accessToken";

        var token = sessionStorage.getItem(tokenKey);

        fetch('api/main/AnalyticsList', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                'Authorization': 'Bearer ' + token
            },
            body: JSON.stringify()
        })
            .then(response => response.json())
            .then(data => {
                this.setState({ analyticsItems: data });
            });
    }

    render() {


        return (
            <div>
                <Grid fluid className="positionGrid">
                    <Row>
                        <Col lg={12}>
                            <Button
                                className="toolboxButton"
                                text={'Загрузить документ'}
                                type={'default'}
                                width={200}
                                onClick={this.showAddDocument}
                            />
                            <Button
                                className="toolboxButton"
                                text={'Удалить'}
                                type={'danger'}
                                width={200}
                                visible={this.state.removeButtonVisible}
                                onClick={this.onRemoveButtonClick}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <Panel header="Рекомендации, советы, анализ рынка от наших аналитиков">
                                <DataGrid
                                    dataSource={this.state.analyticsItems}
                                    allowColumnReordering={true}
                                    allowColumnResizing={true}
                                    columnAutoWidth={true}
                                    hoverStateEnabled={true}
                                    showColumnLines={false}
                                    showRowLines={true}
                                    showBorders={false}
                                    onSelectionChanged={this.onSelectionChanged}
                                >
                                    <Selection
                                        mode={'multiple'}
                                        selectAllMode={'allPages'}
                                        showCheckBoxesMode={'onClick'}
                                    />
                                    <HeaderFilter visible={true} />
                                    <FilterRow visible={true} />
                                    <FilterPanel visible={false} />
                                    <Column
                                        dataField={'createDate'}
                                        caption={'Дата публикации'}
                                        dataType={'date'}>
                                    </Column>
                                    <Column
                                        dataField={'description'}
                                        caption={'Описание'}>
                                    </Column>
                                    <Column
                                        dataField={'fileName'}
                                        caption={'Файл'}
                                        cellRender={AnalyticsDownloadCell}
                                    >
                                    </Column>
                                </DataGrid>
                            </Panel>
                        </Col>
                    </Row>
                </Grid>
                <Popup
                    className={'popup'}
                    visible={this.state.newDocVisible}
                    onHiding={this.hideNewDocument}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Загрузить аналитические материалы'}
                    width={900}
                    height={'auto'}
                >
                    <div>
                        <form id={'form'} ref={this.formElement}
                            method="post"
                            enctype="multipart/form-data"
                            action="/api/main/UploadAnalytics" target="dummyframe"
                        >
                            <Grid fluid>
                                <Row>
                                    <Col lg={12}>
                                        <div>Описание для загружаемых материалов</div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <TextBox name={'description'} />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="fileUploaderContainer">                                            
                                            <FileUploader selectButtonText={'Выберите файл'} labelText={'Или перетащите мышкой сюда'} uploadMode={'useForm'} />                                            
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col lg={12}>
                                        <div className="confirmButtons">
                                            <Button className={'downloadButton'} width={140} text={'Загрузить'} type={'default'} onClick={this.onClick} />
                                            <Button
                                                className="confirmButton"
                                                text={'Отмена'}
                                                type={'default'}
                                                width={140}
                                                onClick={this.onCancelDownloadClick}
                                            />
                                            </div>
                                    </Col>
                                </Row>
                            </Grid>
                        </form>
                    </div>
                </Popup>
                <iframe width="0" height="0" border="0" name="dummyframe" id="dummyframe"></iframe>
                <Popup
                    className={'popup'}
                    visible={this.state.confirmRemoveVisible}
                    onHiding={this.hideNewDocument}
                    dragEnabled={false}
                    closeOnOutsideClick={true}
                    showTitle={true}
                    title={'Подтверждение операции'}
                    width={400}
                    height={'auto'}
                >
                    <div>
                        <Grid fluid>
                            <Row>
                                <Col lg={12}>
                                    <div>Удалить выбранные материалы ({this.state.selectedAnalytics.length})?</div>
                                </Col>
                            </Row>
                            <Row>
                                <Col lg={12}>
                                    <div className="confirmButtons">
                                        <Button
                                            className="confirmButton"
                                            text={'Удалить'}
                                            type={'danger'}
                                            width={140}
                                            onClick={this.onConfirmRemoveClick}
                                        />
                                        <Button
                                            className="confirmButton"
                                            text={'Отмена'}
                                            type={'default'}
                                            width={140}
                                            onClick={this.onCancelRemoveClick}
                                        />
                                    </div>
                                </Col>
                            </Row>
                        </Grid>
                    </div>
                </Popup>
            </div >
        )

    }
}


// WEBPACK FOOTER //
// ./App/containers/analyticsManagement/analyticsManagement.jsx